<script>
import { list } from '@/api/estado'

// Colunas
import columns from './colunas'

export default {
  props: {
    mode: { type: String, default: 'tab' }
  },
  data () {
    return {
      columns: columns,
      indices: [
        { value: 'uf', label: 'UF' },
        { value: 'estado', label: 'Nome' }
      ]
    }
  },
  methods: {
    refresh (data) {
      if (this.mode === 'tab') this.$refs.completeGrid.refreshList()
      else if (this.mode === 'modal') this.$refs.completeGrid.changeBusca(data)
    },
    async getList (filtros) {
      let data = await list(filtros)
      return {
        data: data.data,
        totalCount: data.total
      }
    },
    async selecionar (selecionado) {
      if (selecionado.uf) this.$emit('save', selecionado)
    }
  }
}
</script>

<template>
  <ui-layout-modal :mode="mode" title="Listar Estado" @onClose="() => $emit('cancel')">
    <ui-complete-grid
      ref="completeGrid"
      :columns="columns"
      :indices="indices"
      :selection="mode === 'modal'"
      :datasource="getList"
      @onSelect="selecionar"
      @onCancel="$emit('cancel')" />
  </ui-layout-modal>
</template>
